<div class="item-grid-container">
    <div class="retailer-details-grid search-holder">
      <ul class="list-inline grid-top-actions mb-3">
        <li class="list-inline-item ">
          <input
            type="text"
            placeholder="{{ 'pages.newRetailer.search' | translate }}"
            matInput
            class="
              rounded-pill
              px-3
              py-2
              mb-0
              border-0
              bg-light
              w-100
              me-0
              input-search
              ms-3
            "
            (keyup)="quickSearch()"
            [(ngModel)]="searchValue"
          />
          <i
            color="primary"
            class="search-icon-holder"
            matSuffix
            mat-icon-button
            aria-label="Search"
          >
            <mat-icon>search</mat-icon>
          </i>
        </li>
  
        
        <li class="list-inline-item float-end mx-2">
          <button
            mat-stroked-button
            class="bg-theme"
            routerLinkActive="router-link-active"
            (click)="mapRetailerConfig()"
          >
            Map
            <i class="mi mi-link ms-2 smaill-icon"></i>
          </button>
        </li>
      </ul>
  
      <ag-grid-angular
        style="width: 100%; height: 65vh; max-height: 70vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="rowSelection"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
        
      [suppressRowClickSelection]="true"
      >
      </ag-grid-angular>
    </div>
  </div>
  